import { CallAPIAction, Status } from 'api/types'
import { VisaInquiryResponse } from 'api/evisaAPI/visas'
import { Nationality, ObjectWithTranslation, Occupation } from 'common/types/transformedRespTypes'
import { formatObjectWithTranslationFromBE } from 'common/utils/objectWithTranslation'
import { VisaIssueRequestServiceFields, VisaIssueRequestStatus, VisaStatus } from 'common/types/commonTypes'
import Actions from 'redux/actions'

type State = {
  request?: {
    visa?: {
      id: string
      status: VisaStatus
      followupNumber: number
      followupDate: string
      borderNumber: number
      pdfId: string | null
      owner: {
        name: string
        idNumber: number
      }
      issueRequest: {
        isDisable: boolean
      }
    }
    nationality: Nationality
    occupation: Occupation
    visaIssuePlace: ObjectWithTranslation
    id: number
    createdAt: string
    status: VisaIssueRequestStatus
    rejectionReasons: Array<ObjectWithTranslation>
  } & VisaIssueRequestServiceFields
  nicInfo?: {
    firstName: string
    lastName: string
    maritalStatus: string
    gender: string
    status: string
  }
} & Status

const initialState = {
  nicInfo: undefined,
  request: undefined,
  isLoading: false,
  success: false,
  fail: false,
}

const convertResponseToState = ({ request, nicInfo }: VisaInquiryResponse) => ({
  nicInfo: {
    gender: nicInfo.gender,
    maritalStatus: nicInfo.maritalStatus,
    firstName: nicInfo.firstName,
    lastName: nicInfo.lastName,
    status: nicInfo.status,
  },
  request: {
    visa: request.visa ? request.visa : undefined,
    nationality: request.nationality,
    occupation: request.occupation,
    visaIssuePlace: request.visaIssuePlace,
    id: request.id,
    createdAt: request.createdAt.date,
    status: request.status,
    rejectionReasons: request.rejectionReasons.map((reason) => formatObjectWithTranslationFromBE(reason)),
    pendingUnifiedEligibilityIssue: request.pendingUnifiedEligibilityIssue,
  },
})

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.VISA_INQUIRY_ASYNC,
    Actions.VISA_INQUIRY_SUCCESS,
    Actions.VISA_INQUIRY_FAIL,
    VisaInquiryResponse
  >,
): State => {
  switch (action.type) {
    case Actions.VISA_INQUIRY_ASYNC:
    case Actions.VISA_INQUIRY_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.VISA_INQUIRY_SUCCESS: {
      const { payload } = action

      return {
        ...state,
        ...action.status,
        ...convertResponseToState(payload),
      }
    }
    default:
      return state
  }
}
